import { request } from "@/api/request"

export function wechatLogin() {
  return request.get("/mgm-crm-api/wechat/login").then(r => r.data)
}

